import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import './styles/responsive.scss'
import './plugins/element.js'
import i18n from './lang/index'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload,{
  preLoad: 1.3,           // 预加载高度比例
  error: '/static/error.png',   // 加载失败占位图
  loading: '/static/loading.gif', // 加载中占位图
  attempt: 1,             // 尝试加载次数
  throttleWait: 200       // 节流时间（ms）
})
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
